<!-- src/components/new-tip/MapPreview.vue -->
<template>
  <l-map
    v-if="latitude && longitude"
    :zoom="zoom"
    :center="center"
    :options="{ zoomControl: true, scrollWheelZoom: false }"
    style="height: 240px; width: 100%; border-radius: 4px; z-index: 0;"
  >
    <l-tile-layer :url="tileUrl" :attribution="attribution" />
    <l-marker :lat-lng="center">
      <l-popup>
        <div class="text-caption">
          <strong>Position visite</strong><br>
          {{ latitude }}, {{ longitude }}<br>
          <span v-if="accuracy">Précision : {{ Math.round(accuracy) }} m</span>
        </div>
      </l-popup>
    </l-marker>
    <l-circle
      v-if="accuracy && accuracy > 0"
      :lat-lng="center"
      :radius="accuracy"
      :weight="1"
      color="#1976D2"
      fill-color="#1976D2"
      :fill-opacity="0.15"
    />
  </l-map>
  <div v-else class="text-caption grey--text pa-4 grey lighten-4 text-center">
    Aucune géolocalisation disponible
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup, LCircle } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

// Fix icône Leaflet manquante avec webpack
import L from 'leaflet';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconUrl, iconRetinaUrl, shadowUrl });

export default {
  name: 'NewTipMapPreview',
  components: { LMap, LTileLayer, LMarker, LPopup, LCircle },
  props: {
    latitude:  { type: [Number, String], default: null },
    longitude: { type: [Number, String], default: null },
    accuracy:  { type: [Number, String], default: null },
    zoom: { type: Number, default: 15 },
  },
  data() {
    return {
      tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '© OpenStreetMap',
    };
  },
  computed: {
    center() { return [Number(this.latitude), Number(this.longitude)]; },
  },
};
</script>
